import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";

export default function LeadCapturePopup() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") return;

    const timer = setTimeout(() => {
      setOpen(true);
    }, 7000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  useEffect(() => {
    const handleOpenEvent = () => setOpen(true);
    window.addEventListener("open-lead-capture", handleOpenEvent);
    return () =>
      window.removeEventListener("open-lead-capture", handleOpenEvent);
  }, []);

  useEffect(() => {
    // Luister naar succesvolle inzending van de iframe om de popup te sluiten
    const handleMessage = (e: MessageEvent) => {
      if (
        e.data &&
        (e.data.type === "form-submit-success" ||
          e.data === "form-submit-success" ||
          String(e.data).includes("success"))
      ) {
        setTimeout(() => {
          setOpen(false);
        }, 3000);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    if (open && !document.getElementById("form-embed-script")) {
      const script = document.createElement("script");
      script.id = "form-embed-script";
      script.src = "https://link.cloudschaap.nl/js/form_embed.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        onInteractOutside={(e) => e.preventDefault()}
        className="w-[95vw] sm:w-[400px] max-w-[400px] max-h-[100vh] p-0 border-none bg-transparent shadow-none overflow-hidden no-scrollbar [&>button.absolute]:hidden flex justify-center items-center"
        aria-describedby={undefined}
      >
        <DialogTitle className="sr-only">Inschrijven</DialogTitle>
        <div className="relative w-full bg-transparent scale-[0.7] md:scale-[0.8] origin-center no-scrollbar">
          <DialogPrimitive.Close className="absolute z-[60] top-0 right-0 sm:-top-3 sm:-right-3 w-8 h-8 sm:w-10 sm:h-10 bg-[#0b1021] border-2 border-white rounded-full flex items-center justify-center text-white shadow-xl hover:bg-slate-800 transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 translate-x-1/3 -translate-y-1/3 sm:translate-x-0 sm:translate-y-0">
            <X className="w-4 h-4 sm:w-5 sm:h-5" />
            <span className="sr-only">Sluiten</span>
          </DialogPrimitive.Close>
          <div className="w-full relative flex flex-col h-[950px] overflow-hidden no-scrollbar rounded-2xl">
            <iframe
              src="https://link.cloudschaap.nl/widget/form/oUmlKVoyd0kWXXDNk2Ko"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "950px",
                border: "none",
                background: "transparent",
                overflow: "hidden",
              }}
              scrolling="no"
              id="inline-oUmlKVoyd0kWXXDNk2Ko"
              data-layout="{'id':'INLINE'}"
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="neverDeactivate"
              data-deactivation-value=""
              data-form-name="Cheatsheet Form"
              data-height="950"
              data-layout-iframe-id="inline-oUmlKVoyd0kWXXDNk2Ko"
              data-form-id="oUmlKVoyd0kWXXDNk2Ko"
              title="Cheatsheet Form"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
